import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators'
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons'
import { ShowMinimizePopUp } from '../type/modal-for-report-type'
import { WeatherRoutingModel } from '../../../src/models/weather-routing-reports-model'
import { SHOW_MINIMIZED_REPORT, SHOW_WNI_REPORT_POPUP } from '../../../src/models/weather-routing-reports-model-impl'
import { FeatureFlagModel, FeatureFlagsEvents } from '../../../src/models/feature-flag-model'

@customElement('minimized-report')
export class MinimizedReport extends LitElement {
    static get styles() {
        return [
            css`
                .container-minimize-report {
                    background-color: #b80012;
                    margin-bottom: 20px;
                    width: 168px;
                    border: 1px solid #cecece;
                    border-radius: 8px;
                    color: #fffbfb;
                    gap: 12px;
                    text-align: center;
                    height: 45px;
                    align-items: center;
                    display: flex;
                    justify-content: space-between;
                    padding-left: 24px;
                    padding-right: 24px;
                    cursor: pointer;
                    font-family: Maersk Text;
                }
            `,
        ]
    }
    @property({ attribute: true }) showMinimizePopUp: ShowMinimizePopUp = {
        minimizedPopUp: true,
        reportType: '',
        scheduleId: '',
        reportId: '',
    }

    private _minimizedReportHandler?: (e: Event) => void;

    constructor() {
        super()

        this._showMinimizedReport = this._showMinimizedReport.bind(this)
        this._onFeatureFlagsUpdated = this._onFeatureFlagsUpdated.bind(this)
        this._minimizedReportHandler = (e: Event) => this._showMinimizedReport(e);
    }

    connectedCallback() {
        super.connectedCallback()
        this._setupEventListeners();
        FeatureFlagModel?.addEventListener('featureFlagsUpdated', this._onFeatureFlagsUpdated);
        this._attachModelEventListeners();
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this._cleanupEventListeners();
        FeatureFlagModel?.removeEventListener('featureFlagsUpdated', this._onFeatureFlagsUpdated);
    }

    private _attachModelEventListeners() {
        const attachListener = () => {
            const wrModel = WeatherRoutingModel;
            if (wrModel && this._minimizedReportHandler) {
            wrModel.removeEventListener(SHOW_MINIMIZED_REPORT, this._minimizedReportHandler);
            wrModel.addEventListener(SHOW_MINIMIZED_REPORT, this._minimizedReportHandler);
            return true;
            }
            return false;
        };

        if (attachListener()) return;

        // wait for model initialization
        const handleInit = (e: Event) => {
            const custom = (e as CustomEvent).detail;
            if (custom.weatherRoutingEnabled && attachListener()) {
                window.removeEventListener(FeatureFlagsEvents.featureBasedFlagsInitialized, handleInit);
            }
        };

        window.addEventListener(FeatureFlagsEvents.featureBasedFlagsInitialized, handleInit);
    }

    private _setupEventListeners() {
        if (this._minimizedReportHandler) {
            WeatherRoutingModel?.addEventListener(SHOW_MINIMIZED_REPORT, this._minimizedReportHandler);
        }
    }

    private _cleanupEventListeners() {
        if (this._minimizedReportHandler) {
            WeatherRoutingModel?.removeEventListener(SHOW_MINIMIZED_REPORT, this._minimizedReportHandler);
        }
    }

    private _onFeatureFlagsUpdated() {
        // Re-setup listeners in case models were just initialized
        this._setupEventListeners();
    }
    private _showMinimizedReport(e: Event) {
        this.showMinimizePopUp = { ...(e as CustomEvent).detail }
    }

    render() {

        if (this.showMinimizePopUp.minimizedPopUp) {
            // true then dont show
            return
        }
        return html`
            <div
                class="container-minimize-report"
                @click=${() => {
                    WeatherRoutingModel!.dispatchEvent(
                        new CustomEvent(SHOW_WNI_REPORT_POPUP, {
                            detail: {
                                ...this.showMinimizePopUp,
                                minimizedPopUp: true,
                                reportType: 'Departure', 
                                fromNotification: false,
                            },
                        }),
                    )
                }}
            >
                Report Details ${SvgIcons.expandWhite}
            </div>
        `
    }
}
